import createStore from "APP_ROOT/createStore";

export default function useDispatch() {
  return createStore().dispatch;
}



// WEBPACK FOOTER //
// ./app/hooks/useDispatch.js